angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsRedirectCtrl", [
  '$stateParams'
  '$location'
  ($stateParams, $location) ->
    switch $stateParams.to
      when "logout"
        $location.path '/logout'
]
